const IPFS_GATEWAYS = [
  'https://gateway.pinata.cloud/ipfs/',
  'https://ipfs.filebase.io/ipfs/',
  'https://gateway.4everland.co/ipfs/',
  'https://dweb.link/ipfs/',
  'https://ipfs.io/ipfs/',
];

const IPNS_GATEWAYS = [
  'https://dweb.link/ipns/',
  'https://ipfs.io/ipns/',
];

const unique = (values) => [...new Set(values.filter(Boolean))];

export const normalizeMetadataUri = (uri) => {
  if (typeof uri !== 'string') return uri;

  const value = uri.trim();
  const [path, suffix = ''] = value.split(/(?=[?#])/u, 2);

  // The Derps contract returns extensionless numeric IPFS paths even though
  // the collection was uploaded as `<tokenId>.json` files.
  if (/^ipfs:\/\/.+\/\d+$/i.test(path)) return `${path}.json${suffix}`;

  return value;
};

export const uriCandidates = (uri) => {
  if (typeof uri !== 'string' || !uri.trim()) return [];

  const value = uri.trim();

  if (value.startsWith('ipfs://')) {
    const path = value.slice('ipfs://'.length).replace(/^ipfs\//, '');
    return IPFS_GATEWAYS.map((gateway) => `${gateway}${path}`);
  }

  if (value.startsWith('ipns://')) {
    const path = value.slice('ipns://'.length).replace(/^ipns\//, '');
    return IPNS_GATEWAYS.map((gateway) => `${gateway}${path}`);
  }

  const gatewayMatch = value.match(/^https?:\/\/[^/]+\/(ipfs|ipns)\/(.+)$/i);
  if (gatewayMatch) {
    const [, protocol, path] = gatewayMatch;
    const gateways = protocol.toLowerCase() === 'ipfs' ? IPFS_GATEWAYS : IPNS_GATEWAYS;
    return unique([value, ...gateways.map((gateway) => `${gateway}${path}`)]);
  }

  return [value];
};

const decodeDataJson = (uri) => {
  const commaIndex = uri.indexOf(',');
  if (commaIndex < 0) throw new Error('Invalid metadata data URI');

  const header = uri.slice(0, commaIndex);
  const payload = uri.slice(commaIndex + 1);
  const json = header.includes(';base64') ? atob(payload) : decodeURIComponent(payload);
  return JSON.parse(json);
};

export const fetchJsonWithFallback = async (uri, { signal } = {}) => {
  uri = normalizeMetadataUri(uri);
  if (uri.startsWith('data:application/json')) return decodeDataJson(uri);

  const candidates = uriCandidates(uri);
  let lastError;

  for (const candidate of candidates) {
    try {
      const response = await fetch(candidate, {
        signal,
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      lastError = error;
    }
  }

  throw new Error(`Unable to load NFT metadata: ${lastError?.message || 'no valid URI'}`);
};

export const imageCandidates = (metadata) => {
  const image = metadata?.image || metadata?.image_url || metadata?.imageUrl;
  return uriCandidates(image);
};
